import LenderSidebar from "../components/lender-sidebar.vue";
import { useAccountStoreActions } from "@Client/@Modules/main/store/account/account-helpers";
import { fullName } from "@Shared/@Utils/helpers/text";
import * as AccountActions from "../store/account/account-actions";
import { useRoute } from "@Shared/@Composables/route/useRoute";
import { defineComponent, ref } from "@vue/composition-api";
import { GuestLender } from "@Client/@Routes/pages";
import LenderCodeVerificationPage from "@Client/@Modules/utils-components/lender-code-verification-page.vue";
import store from "../../../store";
import Vue from "vue";
export default defineComponent({
  name: "LenderSidebarLayout",
  components: {
    LenderSidebar,
    GuestLender,
    LenderCodeVerificationPage
  },
  beforeRouteUpdate() {
    location.reload();
  },
  setup() {
    const {
      LOAD_LENDER_DATA,
      VERIFY_LENDER_PIN
    } = useAccountStoreActions([AccountActions.LOAD_LENDER_DATA, AccountActions.VERIFY_LENDER_PIN]);
    const route = useRoute();
    const agent = ref({});
    const genericApplicationData = ref({});
    const loading = ref(true);
    const urlId = ref("");
    const verifyingCode = ref(false);
    const codeVerified = ref(false);
    const verifyLenderCode = async lenderCodeToVerify => {
      urlId.value = route.params.urlId;
      verifyingCode.value = true;
      const {
        success
      } = await VERIFY_LENDER_PIN({
        urlId: urlId.value,
        code: lenderCodeToVerify
      });
      if (success) {
        const lenderData = await LOAD_LENDER_DATA({
          urlId: urlId.value,
          offset: 0
        });
        agent.value = lenderData.agent;
        genericApplicationData.value["client"] = lenderData.client;
        genericApplicationData.value["applicationId"] = lenderData.appId;
        genericApplicationData.value["agent"] = fullName(agent.value);
        genericApplicationData.value["documents"] = lenderData.documents;
        loading.value = false;
        codeVerified.value = true;
        const {
          socket
        } = Vue;
        socket.connect(urlId.value, store);
      }
      verifyingCode.value = false;
    };
    return {
      loading,
      agent,
      urlId,
      genericApplicationData,
      codeVerified,
      verifyingCode,
      verifyLenderCode
    };
  }
});